import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import Logo from './resh.png'
const Navbar = () => {
    const [isMobile, setIsMobile] = useState(false);

    const handleToggle = () => {
        setIsMobile(!isMobile);
    };

    return (
        <div className="navbar">
            <div className="logo">
                <img src={Logo} alt='Logo'/>
            </div>
            <ul className={`nav-links ${isMobile ? 'mobile' : ''}`}>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">Why us</Link></li>
                <li><Link to="/contact">Contact</Link></li>
            </ul>
            <div className="menu-icon" onClick={handleToggle}>
                {isMobile ? 'X' : '☰'}
            </div>
        </div>
    );
};

export default Navbar;
